var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import config from "../../../config";
var API_URL = config.API_URL;
var defaultOptions = {
    headers: new Headers({ "content-type": "application/json" }),
    credentials: "include",
};
export function get(customerId) {
    return fetch("".concat(API_URL, "/customers/").concat(customerId, "/favorites?per_page=2000"), defaultOptions).then(handleInitialResponse);
}
export function create(customerId, productId) {
    return fetch("".concat(API_URL, "/customers/").concat(customerId, "/favorites"), __assign(__assign({}, defaultOptions), { method: "POST", body: JSON.stringify({ product_id: productId }) })).then(handleResponse);
}
export function destroy(customerId, favoriteId) {
    return fetch("".concat(API_URL, "/customers/").concat(customerId, "/favorites/").concat(favoriteId), __assign(__assign({}, defaultOptions), { method: "DELETE" })).then(handleResponse);
}
function handleResponse(response) {
    if (!response.ok) {
        if ([401, 403].includes(response.status)) {
            window.location.href = "/cart/logoff.php?next=".concat(encodeURIComponent(window.location.pathname));
        }
        return Promise.reject({
            status: response.status,
            statusText: response.statusText,
        });
    }
    return response.headers.get("content-type") === "application/json" ? response.json() : response.text();
}
function handleInitialResponse(response) {
    if (!response.ok) {
        if ([403].includes(response.status)) {
            window.location.href = "/cart/logoff.php?next=".concat(encodeURIComponent(window.location.pathname));
        }
        return Promise.reject({
            status: response.status,
            statusText: response.statusText,
        });
    }
    return response.headers.get("content-type") === "application/json" ? response.json() : response.text();
}
//# sourceMappingURL=FavoritesClient.js.map